// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-dialog-modal {
  display: grid;
  place-items: center;
  padding: var(--space-4, 16px);
}
.delete-dialog-backdrop {
  background: var(--overlay-scrim, rgba(20, 38, 36, 0.52)) !important;
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
}
.delete-dialog {
  position: relative;
  width: min(440px, calc(100vw - 32px));
  padding: var(--space-6, 24px);
  border: 1px solid var(--border-subtle, #dce3e2);
  border-radius: var(--radius-lg, 14px);
  outline: 0;
  background: var(--surface-primary, #fff);
  box-shadow: var(--elevation-xl, 0 24px 48px -12px rgba(14, 26, 32, 0.24));
  color: var(--text-primary, #142624);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
}
.delete-dialog-header {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 32px;
  align-items: center;
  gap: var(--space-3, 12px);
}
.delete-dialog-icon {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: var(--radius-full, 9999px);
  background: var(--danger-soft, #fff1ef);
  color: var(--danger-text, #b42318);
}
.delete-dialog-icon svg {
  width: 20px;
  height: 20px;
}
.delete-dialog h2 {
  margin: 0;
  color: var(--text-primary, #142624);
  font-size: 18px;
  font-weight: var(--font-weight-semibold, 600);
  line-height: 1.4;
  letter-spacing: -0.18px;
}
.delete-dialog-close {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-secondary, #506360);
  cursor: pointer;
}
.delete-dialog-close:hover:not(:disabled) {
  background: var(--surface-secondary, #f4f7f7);
  color: var(--text-primary, #142624);
}
.delete-dialog-close:focus-visible,
.delete-dialog-button:focus-visible {
  outline: 2px solid var(--focus-ring, #0f766e);
  outline-offset: 2px;
  box-shadow: none;
}
.delete-dialog > p {
  margin: var(--space-5, 20px) 0 0;
  color: var(--text-secondary, #506360);
  font-size: 14px;
  font-weight: var(--font-weight-regular, 400);
  line-height: 1.55;
}
.delete-dialog-error {
  margin-top: var(--space-3, 12px);
  padding: var(--space-3, 12px);
  border: 1px solid var(--danger-border, #f2b8b3);
  border-radius: var(--radius-sm, 6px);
  background: var(--danger-soft, #fff1ef);
  color: var(--danger-text, #b42318);
  font-size: 13px;
  line-height: 18px;
}
.delete-dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2, 8px);
  margin-top: var(--space-6, 24px);
}
.delete-dialog-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2, 8px);
  min-height: var(--control-md, 40px);
  padding: 0 var(--space-4, 16px);
  border-radius: var(--radius-md, 10px);
  font: var(--font-weight-medium, 500) 13px/1
    var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.delete-dialog-button > svg {
  display: block;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}
.delete-dialog-button.cancel {
  border: 1px solid var(--border-default, #cdd6d4);
  background: var(--surface-primary, #fff);
  color: var(--text-primary, #142624);
}
.delete-dialog-button.danger {
  border: 1px solid transparent;
  background: var(--danger-soft, #fff1ef);
  color: var(--danger-text, #b42318);
}
.delete-dialog-button.confirm {
  border: 1px solid var(--interactive-default, #0f766e);
  background: var(--interactive-default, #0f766e);
  color: var(--on-interactive-primary, #fff);
}
.delete-dialog-button.cancel:hover:not(:disabled) {
  border-color: var(--border-strong, #aebab8);
  background: var(--surface-secondary, #f4f7f7);
}
.delete-dialog-button.danger:hover:not(:disabled) {
  border-color: var(--danger-border, #f2b8b3);
  background: var(--danger-soft, #fff1ef);
  color: var(--danger-text, #b42318);
  filter: brightness(0.98);
}
.delete-dialog button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.editor-delete-confirmation.MuiModal-root { z-index: 11000; }
.editor-delete-confirmation .delete-dialog-backdrop {
  background: var(--overlay-default, rgb(0 0 0 / 45%)) !important;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
.editor-delete-confirmation .delete-dialog {
  display: flex;
  flex-direction: column;
  width: min(520px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  border-radius: var(--radius-lg, 16px);
  padding: 0;
  overflow: hidden;
}
.editor-delete-confirmation .delete-dialog-header {
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;
  padding: var(--space-5, 20px) var(--space-6, 24px);
  border-bottom: 1px solid var(--border-subtle, #dce3e2);
}
.editor-delete-confirmation .delete-dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-4, 16px);
  min-height: 0;
  padding: var(--space-8, 32px) var(--space-6, 24px);
  overflow-y: auto;
  text-align: center;
}
.editor-delete-confirmation .delete-dialog-content .delete-dialog-icon {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
}
.editor-delete-confirmation .delete-dialog-content .delete-dialog-icon svg { width: 28px; height: 28px; }
.editor-delete-confirmation .delete-dialog-content p {
  margin: 0;
  color: var(--text-secondary, #506360);
  font-size: 16px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.editor-delete-confirmation .delete-dialog-error { margin: 0 24px 20px; }
.editor-delete-confirmation .delete-dialog-actions {
  flex-shrink: 0;
  margin-top: 0;
  padding: var(--space-5, 20px) var(--space-6, 24px);
  border-top: 1px solid var(--border-subtle, #dce3e2);
}
@media (max-width: 600px) {
  .delete-dialog-modal.settings-bottom-sheet-confirmation {
    align-items: end;
    padding: 0;
  }
  .settings-bottom-sheet-backdrop {
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }
  .settings-bottom-sheet-confirmation .delete-dialog {
    width: 100%;
    max-height: calc(100dvh - 16px);
    overflow-y: auto;
    overscroll-behavior: contain;
    border-radius: 20px 20px 0 0;
    padding: 20px 16px calc(16px + env(safe-area-inset-bottom));
  }
  .delete-dialog {
    padding: var(--space-5, 20px);
    border-radius: var(--radius-md, 10px);
  }
  .delete-dialog-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .delete-dialog-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DeleteConfirmationDialog/DeleteConfirmationDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,mEAAmE;EACnE,kCAA0B;UAA1B,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,+CAA+C;EAC/C,qCAAqC;EACrC,UAAU;EACV,wCAAwC;EACxC,yEAAyE;EACzE,mCAAmC;EACnC,6DAA6D;AAC/D;AACA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;AACA;;EAEE,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,eAAe;EACf,4CAA4C;EAC5C,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,+CAA+C;EAC/C,oCAAoC;EACpC,uCAAuC;EACvC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,gCAAgC;AAClC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;EACnC,+BAA+B;EAC/B,qCAAqC;EACrC;oDACkD;EAClD,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;AACpC;AACA;EACE,qDAAqD;EACrD,+CAA+C;EAC/C,0CAA0C;AAC5C;AACA;EACE,2CAA2C;EAC3C,6CAA6C;AAC/C;AACA;EACE,2CAA2C;EAC3C,uCAAuC;EACvC,kCAAkC;EAClC,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA,4CAA4C,cAAc,EAAE;AAC5D;EACE,+DAA+D;EAC/D,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,+BAA+B;EAC/B,qCAAqC;EACrC,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kDAAkD;EAClD,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA,6EAA6E,WAAW,EAAE,YAAY,EAAE;AACxG;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA,mDAAmD,mBAAmB,EAAE;AACxE;EACE,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,mDAAmD;AACrD;AACA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,4BAA4B;IAC5B,4BAA4B;IAC5B,2DAA2D;EAC7D;EACA;IACE,6BAA6B;IAC7B,qCAAqC;EACvC;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".delete-dialog-modal {\n  display: grid;\n  place-items: center;\n  padding: var(--space-4, 16px);\n}\n.delete-dialog-backdrop {\n  background: var(--overlay-scrim, rgba(20, 38, 36, 0.52)) !important;\n  backdrop-filter: blur(3px);\n}\n.delete-dialog {\n  position: relative;\n  width: min(440px, calc(100vw - 32px));\n  padding: var(--space-6, 24px);\n  border: 1px solid var(--border-subtle, #dce3e2);\n  border-radius: var(--radius-lg, 14px);\n  outline: 0;\n  background: var(--surface-primary, #fff);\n  box-shadow: var(--elevation-xl, 0 24px 48px -12px rgba(14, 26, 32, 0.24));\n  color: var(--text-primary, #142624);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n}\n.delete-dialog-header {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr) 32px;\n  align-items: center;\n  gap: var(--space-3, 12px);\n}\n.delete-dialog-icon {\n  display: grid;\n  width: 36px;\n  height: 36px;\n  place-items: center;\n  border-radius: var(--radius-full, 9999px);\n  background: var(--danger-soft, #fff1ef);\n  color: var(--danger-text, #b42318);\n}\n.delete-dialog-icon svg {\n  width: 20px;\n  height: 20px;\n}\n.delete-dialog h2 {\n  margin: 0;\n  color: var(--text-primary, #142624);\n  font-size: 18px;\n  font-weight: var(--font-weight-semibold, 600);\n  line-height: 1.4;\n  letter-spacing: -0.18px;\n}\n.delete-dialog-close {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  place-items: center;\n  padding: 0;\n  border: 0;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-secondary, #506360);\n  cursor: pointer;\n}\n.delete-dialog-close:hover:not(:disabled) {\n  background: var(--surface-secondary, #f4f7f7);\n  color: var(--text-primary, #142624);\n}\n.delete-dialog-close:focus-visible,\n.delete-dialog-button:focus-visible {\n  outline: 2px solid var(--focus-ring, #0f766e);\n  outline-offset: 2px;\n  box-shadow: none;\n}\n.delete-dialog > p {\n  margin: var(--space-5, 20px) 0 0;\n  color: var(--text-secondary, #506360);\n  font-size: 14px;\n  font-weight: var(--font-weight-regular, 400);\n  line-height: 1.55;\n}\n.delete-dialog-error {\n  margin-top: var(--space-3, 12px);\n  padding: var(--space-3, 12px);\n  border: 1px solid var(--danger-border, #f2b8b3);\n  border-radius: var(--radius-sm, 6px);\n  background: var(--danger-soft, #fff1ef);\n  color: var(--danger-text, #b42318);\n  font-size: 13px;\n  line-height: 18px;\n}\n.delete-dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-2, 8px);\n  margin-top: var(--space-6, 24px);\n}\n.delete-dialog-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2, 8px);\n  min-height: var(--control-md, 40px);\n  padding: 0 var(--space-4, 16px);\n  border-radius: var(--radius-md, 10px);\n  font: var(--font-weight-medium, 500) 13px/1\n    var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.delete-dialog-button > svg {\n  display: block;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n}\n.delete-dialog-button.cancel {\n  border: 1px solid var(--border-default, #cdd6d4);\n  background: var(--surface-primary, #fff);\n  color: var(--text-primary, #142624);\n}\n.delete-dialog-button.danger {\n  border: 1px solid transparent;\n  background: var(--danger-soft, #fff1ef);\n  color: var(--danger-text, #b42318);\n}\n.delete-dialog-button.confirm {\n  border: 1px solid var(--interactive-default, #0f766e);\n  background: var(--interactive-default, #0f766e);\n  color: var(--on-interactive-primary, #fff);\n}\n.delete-dialog-button.cancel:hover:not(:disabled) {\n  border-color: var(--border-strong, #aebab8);\n  background: var(--surface-secondary, #f4f7f7);\n}\n.delete-dialog-button.danger:hover:not(:disabled) {\n  border-color: var(--danger-border, #f2b8b3);\n  background: var(--danger-soft, #fff1ef);\n  color: var(--danger-text, #b42318);\n  filter: brightness(0.98);\n}\n.delete-dialog button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.editor-delete-confirmation.MuiModal-root { z-index: 11000; }\n.editor-delete-confirmation .delete-dialog-backdrop {\n  background: var(--overlay-default, rgb(0 0 0 / 45%)) !important;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n.editor-delete-confirmation .delete-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(520px, calc(100vw - 32px));\n  max-height: calc(100dvh - 32px);\n  border-radius: var(--radius-lg, 16px);\n  padding: 0;\n  overflow: hidden;\n}\n.editor-delete-confirmation .delete-dialog-header {\n  display: flex;\n  justify-content: space-between;\n  flex-shrink: 0;\n  padding: var(--space-5, 20px) var(--space-6, 24px);\n  border-bottom: 1px solid var(--border-subtle, #dce3e2);\n}\n.editor-delete-confirmation .delete-dialog-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-4, 16px);\n  min-height: 0;\n  padding: var(--space-8, 32px) var(--space-6, 24px);\n  overflow-y: auto;\n  text-align: center;\n}\n.editor-delete-confirmation .delete-dialog-content .delete-dialog-icon {\n  flex-shrink: 0;\n  width: 64px;\n  height: 64px;\n}\n.editor-delete-confirmation .delete-dialog-content .delete-dialog-icon svg { width: 28px; height: 28px; }\n.editor-delete-confirmation .delete-dialog-content p {\n  margin: 0;\n  color: var(--text-secondary, #506360);\n  font-size: 16px;\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n.editor-delete-confirmation .delete-dialog-error { margin: 0 24px 20px; }\n.editor-delete-confirmation .delete-dialog-actions {\n  flex-shrink: 0;\n  margin-top: 0;\n  padding: var(--space-5, 20px) var(--space-6, 24px);\n  border-top: 1px solid var(--border-subtle, #dce3e2);\n}\n@media (max-width: 600px) {\n  .delete-dialog-modal.settings-bottom-sheet-confirmation {\n    align-items: end;\n    padding: 0;\n  }\n  .settings-bottom-sheet-backdrop {\n    backdrop-filter: none;\n    -webkit-backdrop-filter: none;\n  }\n  .settings-bottom-sheet-confirmation .delete-dialog {\n    width: 100%;\n    max-height: calc(100dvh - 16px);\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    border-radius: 20px 20px 0 0;\n    padding: 20px 16px calc(16px + env(safe-area-inset-bottom));\n  }\n  .delete-dialog {\n    padding: var(--space-5, 20px);\n    border-radius: var(--radius-md, 10px);\n  }\n  .delete-dialog-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n  .delete-dialog-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
